/**
 * cookie获取
 */
export function getCookie(key) {
    const reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)');
    const arr = document.cookie.match(reg);
    return arr ? unescape(arr[2]) : null;
}

/**
 * 对象扩展
 */
const hasOwn = Object.prototype.hasOwnProperty;
export function extend(obj) {
    let source;
    let prop;

    for (let i = 1, length = arguments.length; i < length; i++) {
        source = arguments[i];
        /* eslint no-restricted-syntax:off  */
        for (prop in source) {
            if (hasOwn.call(source, prop)) {
                /* eslint no-param-reassign: off */
                obj[prop] = source[prop];
            }
        }
    }
    return obj;
}
